import {
  BrandAndMarketListItem,
  GuidIdAndLabel,
  GuidIdCodeAndLabel,
  Int32IdAndLabel
} from '../../../integrated-client/models';

export const MINIMUM_TIMEOUT_SECONDS = 65;
export interface IIdentitySettingsEditorData {
  id?: string | null;
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannel?: Int32IdAndLabel | null;
  provider?: GuidIdAndLabel | null;
  agency?: GuidIdCodeAndLabel | null;
  effectiveFrom?: object | null;
  effectiveTo?: object | null;
  disabled?: boolean;
  timeout?: number | null;
  allowEdit?: boolean;
}

export interface IEditorData {
  identitySettingsData?: IIdentitySettingsEditorData;
  validation?: any;
}

export class EditorData implements IEditorData {
  identitySettingsData?: IIdentitySettingsEditorData;
  validation?: any;

  constructor() {    
    this.identitySettingsData = { disabled: false, timeout: MINIMUM_TIMEOUT_SECONDS };
  }
}
